import SodColumnChip from './SodColumnChip';
export default SodColumnChip;
